// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import calEntity from './entities/cal.json';
import calMenu from '../pages/cal/menu.json';
import calFullForm from '../pages/cal/forms/full.json';
import calContextForm from '../pages/cal/forms/context.json';
import calMiniForm from '../pages/cal/forms/mini.json';
import calLookupForm from '../pages/cal/forms/lookup.json';
import calTableView from '../pages/cal/views/table.json';
import calStagesView from '../pages/cal/views/stages.json';
import calCardsView from '../pages/cal/views/cards.json';
import calInlineView from '../pages/cal/views/inline.json';
import calBacklogView from '../pages/cal/views/backlog.json';
import calSplitView from '../pages/cal/views/split.json';
import calCalendarView from '../pages/cal/views/calendar.json';
import calDashboardView from '../pages/cal/views/dashboard.json';

/** Тип запису «Подія» зі сторінками пакета: меню, форми та подання з pages/cal/. */
export const calDefinition: IRecordTypeDefinition = {
  ...calEntity,
  views: assembleViewSet({
      table: calTableView,
      stages: calStagesView,
      cards: calCardsView,
      inline: calInlineView,
      backlog: calBacklogView,
      split: calSplitView,
      calendar: calCalendarView,
      dashboard: calDashboardView,
  }),
  form: calFullForm,
  forms: { full: calFullForm, context: calContextForm, mini: calMiniForm, lookup: calLookupForm },
  menu: calMenu,
} as IRecordTypeDefinition;
